module.exports = __webpack_public_path__ + "img/clip-virtual-reality.3222873d.png";